export const ACCOUNT_DETAILS_REQUEST = 'account/ACCOUNT_DETAILS_REQUEST';
export const ACCOUNT_DETAILS_SUCCESS = 'account/ACCOUNT_DETAILS_SUCCESS';
export const ACCOUNT_DETAILS_FAILURE = 'account/ACCOUNT_DETAILS_FAILURE';
export const ACCOUNT_BALANCE_REQUEST = 'account/ACCOUNT_BALANCE_REQUEST';
export const ACCOUNT_BALANCE_FAILURE = 'account/ACCOUNT_BALANCE_FAILURE';
export const ACCOUNT_BALANCE_SUCCESS = 'account/ACCOUNT_BALANCE_SUCCESS';
export const UPDATE_SAVED_SLIPS_COUNT = 'account/UPDATE_SAVED_SLIPS_COUNT';

export const accountDetailsRequest = () => ({
  type: ACCOUNT_DETAILS_REQUEST
});
export const accountDetailsSuccess = (results) => ({
  type: ACCOUNT_DETAILS_SUCCESS,
  results
});
export const accountDetailsFailure = (error) => ({
  type: ACCOUNT_DETAILS_FAILURE,
  error
});
export const accountBalanceRequest = (ignoreHidePeriod = false) => ({
  type: ACCOUNT_BALANCE_REQUEST,
  ignoreHidePeriod
});
export const accountBalanceSuccess = (results) => ({
  type: ACCOUNT_BALANCE_SUCCESS,
  results
});
export const accountBalanceFailure = (error) => ({
  type: ACCOUNT_BALANCE_FAILURE,
  error
});
export const updateSavedSlipsCount = (updateBy) => ({
  type: UPDATE_SAVED_SLIPS_COUNT,
  updateBy
});
